import React from "react";
import { Link } from "@/components/common/Link";
import { Card } from "@/components/ui/card";
import { EcommerceTermsProvider, useEcommerceTerms } from "@/integrations/wordpress/WordPressEcommerceTermsProvider";
import { WP_Term_Query } from "@/integrations/wordpress/wp_term_query";
import { ArrowUpRight } from "lucide-react";
function CuratedOrderConsumer() {
  const {
    terms,
    loading,
    error
  } = useEcommerceTerms();
  if (loading) {
    return <div data-section-id="63867" className="grid grid-cols-1 gap-8 md:grid-cols-3">
        {[...Array(3)].map((_, i) => <div key={i} data-index={i} className="aspect-[3/4] w-full animate-pulse rounded-sm bg-white/5" />)}
      </div>;
  }
  if (error) {
    return <div className="flex h-64 items-center justify-center rounded-sm border border-destructive/20 bg-destructive/10 text-destructive">
        <p className="font-default">Unable to load categories. Please try again later.</p>
      </div>;
  }
  if (!terms || terms.length === 0) {
    return <div className="flex h-64 items-center justify-center rounded-sm border border-white/10 bg-white/5 text-muted-foreground">
        <p className="font-default">No categories available.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
      {terms.map((term, i) => <Link key={term.id} to={term.link ?? "#"} className="group relative block h-full w-full overflow-hidden rounded-sm border border-white/10 bg-white/5 backdrop-blur-md transition-all duration-300 hover:border-primary/40 hover:shadow-[0_0_30px_-10px_rgba(0,255,255,0.3)]" data-index={i}>
          <Card className="h-full w-full border-0 bg-transparent p-0 shadow-none">
            {}
            <div className="aspect-[3/4] w-full overflow-hidden bg-background">
              {term.image_url ? <img src={term.image_url} alt={term.name} className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-white/5 text-muted-foreground">
                  <span className="font-mono text-xs uppercase tracking-widest">No Image</span>
                </div>}
            </div>

            {}
            <div className="absolute inset-0 bg-gradient-to-t from-background via-background/40 to-transparent opacity-80 transition-opacity duration-500 group-hover:opacity-95" />

            {}
            <div className="absolute bottom-0 left-0 w-full p-8 text-foreground">
              <div className="flex items-end justify-between">
                <h3 className="font-default text-2xl font-bold uppercase tracking-tighter text-foreground md:text-3xl">
                  {term.name}
                </h3>
                <div className="flex items-center gap-2 opacity-0 transition-all duration-300 group-hover:-translate-y-1 group-hover:opacity-100">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-primary">Explore</span>
                  <ArrowUpRight className="h-5 w-5 text-primary" />
                </div>
              </div>
              <p className="mt-2 line-clamp-2 text-sm font-sans text-muted-foreground opacity-0 transition-opacity duration-500 group-hover:opacity-100">
                {term.description}
              </p>
            </div>
          </Card>
        </Link>)}
    </div>;
}
export default function CuratedOrder() {
  const wp_term_query_params = {
    taxonomy: "product_cat",
    per_page: 3,
    orderby: "count",
    order: "desc"
  };
  const wp_term_query = new WP_Term_Query(wp_term_query_params);
  return <section id="service-ecosystem" className="dark bg-background text-foreground relative overflow-hidden py-24">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden select-none">
        <span className="font-default text-[20vw] font-black leading-none text-white/5 opacity-50 blur-[2px]">
          ACCESS
        </span>
      </div>

      <div className="container relative z-10 mx-auto px-4">
        <div className="mb-16 flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
          <div className="max-w-2xl">
            <h2 className="font-default text-4xl font-bold tracking-tighter text-foreground md:text-5xl lg:text-6xl">
              Service Ecosystem
            </h2>
            <p className="mt-4 text-lg font-sans text-muted-foreground">
              Discover a curated selection of digital infrastructure and connectivity tools powered by seamless crypto integration.
            </p>
          </div>
        </div>

        <EcommerceTermsProvider wp_term_query={wp_term_query} className="w-full">
          <CuratedOrderConsumer />
        </EcommerceTermsProvider>
      </div>
    </section>;
}